module.exports = __webpack_public_path__ + "static/media/YM17_3.da42a97d.jpg";